<template>
<div class="chapter">
<div class="inner_page">
<h1 class="halftitle" id="pagei">The Mongol Conquests</h1>
<h1 class="halftitle1a"><em class="italic">The Military Operations of Genghis Khan and Sübe’etei</em></h1>
<h2 class="halftitle1">Carl Fredrik Sverdrup</h2>
<p class="logo"><img alt="figure" class="imagu" src="images/pi.jpg"/> Helion &amp; Company Limited</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?f67473ec